import { queryFetch, graphQLFetch } from '../../../core/fetch';
//import config from '../../../config.json';

export const types = {
	INVALIDATE_NEW_ENTRY: 'INVALIDATE_NEW_ENTRY',
	INSERT_NEW_ENTRY: 'INSERT_NEW_ENTRY',
	GET_VISITOR_DATA: 'GET_VISITOR_DATA',
	INSERT_NEW_ENTRY_DETAIL: 'INSERT_NEW_ENTRY_DETAIL',
	REQUEST_VISITER_ENTRIES: 'REQUEST_VISITER_ENTRIES',
	RECEIVE_VISITER_ENTRIES: 'RECEIVE_VISITER_ENTRIES',
	UPDATE_VISITER_ENTRIES: 'UPDATE_VISITER_ENTRIES',
	UPDATE_VISITER_TIME: 'UPDATE_VISITER_TIME',
	REQUEST_VISITER_LIST: 'REQUEST_VISITER_LIST',
	RECEIVE_VISITER_LIST: 'RECEIVE_VISITER_LIST',
	REQUEST_EMPLOYEE_LIST: 'REQUEST_EMPLOYEE_LIST',
	RECEIVE_EMPLOYEE_LIST: 'RECEIVE_EMPLOYEE_LIST',
	SET_SHOW_NEW_ENTRY: 'SET_SHOW_NEW_ENTRY',
	INSERT_NEW_ENTRY_STATUS: 'INSERT_NEW_ENTRY_STATUS',
	SEND_EMPLOYEE_MAIL: 'SEND_EMPLOYEE_MAIL',
	DELETE_VISITER_DATA: 'DELETE_VISITER_DATA',
};

export const newentryActions = {
	invalidateNewEntry() {
		return {
			type: types.INVALIDATE_NEW_ENTRY,
		};
	},
	insertNewEntry(data) {
		return (dispatch, getState) => {
			dispatch({
				type: types.INSERT_NEW_ENTRY,
			});

			dispatch(insertMovementDB(data));
		};
	},
	getVisitorData(data) {
		return (dispatch, getState) => {
			dispatch({
				type: types.GET_VISITOR_DATA,
			});

			dispatch(getVisitor(data));
		};
	},
	setIsDeleted(data) {
		return (dispatch) => {
			dispatch({
				type: types.DELETE_VISITER_DATA,
				payload: {
					isDeleted: data,
				},
			});
		};
	},
	setIsUpdated(data) {
		return (dispatch) => {
			dispatch({
				type: types.UPDATE_VISITER_TIME,
				payload: {
					isUpdated: data,
				},
			});
		};
	},
	setIsLoaded(data) {
		return (dispatch) => {
			dispatch({
				type: types.GET_VISITOR_DATA,
				payload: {
					isLoaded: data,
				},
			});
		};
	},
	insertNewEntryDetail(id, data) {
		return (dispatch, getState) => {
			dispatch({
				type: types.INSERT_NEW_ENTRY_DETAIL,
			});

			dispatch(insertMovementDeatilDB(id, data));
		};
	},
	insertNewEntryStatus(isSuccess) {
		return {
			type: types.INSERT_NEW_ENTRY_STATUS,
			payload: isSuccess,
		};
	},
	requestVisiterEntries() {
		return (dispatch, getState) => {
			const { newentry } = getState();
			dispatch({
				type: types.REQUEST_VISITER_ENTRIES,
			});

			dispatch(requestVisiterEntriesfromDB());
		};
	},
	receiveVisiterEntries(visiterEntries) {
		return (dispatch, getState) => {
			const { newentry } = getState();
			const payload = visiterEntries;
			dispatch({
				type: types.RECEIVE_VISITER_ENTRIES,
				payload: { visiterEntries, ...payload },
			});
		};
	},
	requestVisiterList() {
		return (dispatch, getState) => {
			const { newentry } = getState();
			dispatch({
				type: types.REQUEST_VISITER_LIST,
			});

			dispatch(requestVisiterListfromDB());
		};
	},
	receiveVisiterList(visiterData) {
		return (dispatch, getState) => {
			const { newentry } = getState();
			const payload = visiterData;
			dispatch({
				type: types.RECEIVE_VISITER_LIST,
				payload: { visiterData, ...payload },
			});
		};
	},
	requestEmployeeList() {
		return (dispatch, getState) => {
			const { newentry } = getState();
			dispatch({
				type: types.REQUEST_EMPLOYEE_LIST,
			});

			dispatch(requestEmployeeListfromDB());
		};
	},
	receiveEmployeeList(employeeData) {
		return (dispatch, getState) => {
			const { newentry } = getState();
			const payload = employeeData;
			dispatch({
				type: types.RECEIVE_EMPLOYEE_LIST,
				payload: { employeeData, ...payload },
			});
		};
	},
	updateVisiterEntries(id, status, endtime) {
		return (dispatch, getState) => {
			dispatch({
				type: types.UPDATE_VISITER_ENTRIES,
			});

			dispatch(updateVisiterEntriesfromDB(id, status, endtime));
		};
	},
	updateVisiterTime(data) {
		return (dispatch, getState) => {
			dispatch({
				type: types.UPDATE_VISITER_TIME,
			});

			dispatch(updateVisiterTimefromDB(data));
		};
	},
	deleteVisiterData(data) {
		return (dispatch, getState) => {
			dispatch({
				type: types.DELETE_VISITER_DATA,
			});

			dispatch(deleteVisiterDatafromDB(data));
		};
	},
	setShowNewEntry(isShow) {
		return {
			type: types.SET_SHOW_NEW_ENTRY,
			payload: isShow,
		};
	},
	sendEmployeeMail(entryData) {
		return (dispatch, getState) => {
			dispatch({
				type: types.SEND_EMPLOYEE_MAIL,
			});

			dispatch(sendEmployeeMailfromDB(entryData));
			let visitDate = new Date(entryData.visit_date);
			let tomorrowDate = new Date();
			tomorrowDate.setDate(tomorrowDate.getDate() + 1);
			tomorrowDate.setHours(0, 0, 0, 0);
			if (visitDate >= tomorrowDate) {
				dispatch(sendVisitorMailfromDB(entryData));
			}
		};
	},
};

const requestVisiterListfromDB = () => {
	const query = `movement{
        id
        first_name
        last_name
        gender
        organization
        email_address
        mobile_number
        contact_address1
        contact_address2
        city
        state
        update_date
      }`;
	return (dispatch) => {
		graphQLFetch('post', query).then((result) => {
			let data = result && result.data.movement;
			data = data.filter((g) => g.first_name && g.mobile_number);
			dispatch(newentryActions.receiveVisiterList(data));
		});
	};
};

const requestVisiterEntriesfromDB = () => {
	const query = `movement_details{
        id
        movement_id
        visit_person
        visit_person_long
        visit_team
        visit_purpose
        visit_date
        visit_in_time
        visit_out_time
		visit_note
		visitor_guid
        is_exit
          movemnt {
          id
          first_name
          organization
		  mobile_number
		  email_address
        }
      }`;
	return (dispatch) => {
		graphQLFetch('post', query).then((result) => {
			//console.log(result && result.data);
			var dataToSend = [];
			if (result && result.data) {
				result.data.movement_details.map((c) => {
					const e_data = {
						id: c.id,
						movement_id: c.movement_id,
						visit_person: c.visit_person,
						visit_person_long: c.visit_person_long,
						visit_team: c.visit_team,
						visit_purpose: c.visit_purpose,
						visit_date: c.visit_date,
						visit_in_time: c.visit_in_time,
						visit_out_time: c.visit_out_time,
						visit_note: c.visit_note,
						is_exit: c.is_exit,
						first_name: c.movemnt.first_name,
						organization: c.movemnt.organization,
						mobile_number: c.movemnt.mobile_number,
						email_address: c.movemnt.email_address,
					};
					dataToSend.push(e_data);
				});
			}
			dispatch(newentryActions.receiveVisiterEntries(dataToSend));
		});
	};
};

const updateVisiterEntriesfromDB = (id, status, endtime) => {
	const query = `mutation updateMovementdetails{
        updateMovementdetails(
            id :${id}
            is_exit:"${status}"
            visit_out_time:"${status === 'Y' ? endtime : ''}"
        ) {
            id
        }
      }`;

	return (dispatch) => {
		graphQLFetch('post', {
			query,
		}).then((result) => {
			//console.log(result.data);
			dispatch(newentryActions.requestVisiterEntries());
		});
	};
};

const updateVisiterTimefromDB = (data) => {
	const query = `mutation {updateMovementdetailsguid(
		id: ${data.id},
		visit_in_time: "${data.visit_in_time}",
		visit_date: "${data.visit_date}",
		visit_note: "${data.visit_note}"
		) {
		id			
		}
	}`;

	return (dispatch) => {
		graphQLFetch('post', { query }).then((result) => {
			if (result && result.data) {
				dispatch(newentryActions.setIsUpdated(true));
			}
		});
	};
};

const deleteVisiterDatafromDB = (data) => {
	const query = `mutation {deleteMovementDetails(
		id: ${data}
		)
}`;
	return (dispatch) => {
		graphQLFetch('post', { query }).then((result) => {
			if (result && result.data) {
				dispatch(newentryActions.setIsDeleted(true));
			}
		});
	};
};

const sendEmployeeMailfromDB = (mailData) => {
	const body = JSON.stringify(mailData);
	return (dispatch) => {
		queryFetch('sendmail', '', 'POST', body).then((result) => {
			//var dataList = JSON.parse(result);
		});
	};
};

const sendVisitorMailfromDB = (mailData) => {
	const body = JSON.stringify(mailData);
	return (dispatch) => {
		queryFetch('sendmailvisitor', '', 'POST', body).then((result) => {
			//var dataList = JSON.parse(result);
		});
	};
};

const requestEmployeeListfromDB = () => {
	// return dispatch => {
	// fetch('http://'+config.SERVER_URL+'/api/SampleData/getEmployeeList', {
	//         method: 'POST',
	//         headers: {
	//             'Accept': 'application/json',
	//             'Content-Type': 'application/json'
	//         }
	//     })
	//     .then(response => response.json())
	//         .then(data => {
	//             var dataList = JSON.parse(data);
	//             dispatch(newentryActions.receiveEmployeeList((dataList && dataList)))
	//         })
	//         .catch(error => console.error('Unable to get user data.', error));
	//     }
	return (dispatch) => {
		queryFetch('getEmployeeList', '', 'POST').then((result) => {
			var dataList = JSON.parse(result);
			dispatch(newentryActions.receiveEmployeeList(dataList && dataList));
		});
	};
};

const insertMovementDB = (newEntryData) => {
	if (newEntryData.movement_id <= 0) {
		const query = `mutation addMovement{
            addMovement(
                first_name :"${newEntryData.name}"
                organization:"${newEntryData.organization}"
                email_address:"${newEntryData.email_address}"
                mobile_number:${newEntryData.mobile_number}
            ) {
                id
            }
          }`;

		return (dispatch) => {
			graphQLFetch('post', {
				query,
			}).then((result) => {
				//console.log(result.data);
				dispatch(newentryActions.insertNewEntryDetail(result.data.addMovement.id, newEntryData));
			});
		};
	} else {
		return (dispatch) => {
			dispatch(newentryActions.insertNewEntryDetail(newEntryData.movement_id, newEntryData));
		};
	}
};

const getVisitor = (id) => {
	const query =
		`movement_details_guid(
				visitor_guid: "` +
		id +
		`"
				) {
			id
			movement_id
			visit_person
			visit_person_long
			visit_team
			visit_purpose
			visit_date
			visit_in_time
			visit_out_time
			visit_note
			is_exit
				movemnt {
				id,
				first_name
				last_name
				organization
				mobile_number
				email_address
			}
		}`;
	return (dispatch) => {
		graphQLFetch('post', query).then((result) => {
			if (result && result.data) {
				result.data.movement_details_guid.map((c) => {
					const e_data = [
						{
							id: c.id,
							movement_id: c.movement_id,
							visit_person: c.visit_person,
							visit_person_long: c.visit_person_long,
							visit_team: c.visit_team,
							visit_purpose: c.visit_purpose,
							visit_date: c.visit_date,
							visit_in_time: c.visit_in_time,
							visit_out_time: c.visit_out_time,
							visit_note: c.visit_note,
							is_exit: c.is_exit,
							first_name: c.movemnt.first_name,
							last_name: c.movemnt.last_name,
							organization: c.movemnt.organization,
							mobile_number: c.movemnt.mobile_number,
							email_address: c.movemnt.email_address,
						},
					];
					dispatch(newentryActions.setIsLoaded(e_data));
				});
			}
		});
	};
};

const insertMovementDeatilDB = (id, newEntryData) => {
	const query = `mutation addMovementDetails{
            addMovementDetails(
                movement_id :${id}
                visit_person:"${newEntryData.visit_person}"
                visit_person_long:"${newEntryData.visit_person_long}"
                visit_team:"${newEntryData.visit_team}"
                visit_purpose:"${newEntryData.visit_purpose}"
                visit_note:"${newEntryData.visit_note}"
                visit_date:"${newEntryData.visit_date}"
				visit_in_time:"${newEntryData.visit_in_time}"
				visitor_guid:"${newEntryData.visitor_guid}"
            ) {
                movement_id
            }
          }`;

	return (dispatch) => {
		graphQLFetch('post', {
			query,
		}).then((result) => {
			//console.log(result.data);
			dispatch(newentryActions.requestVisiterEntries());
			dispatch(newentryActions.sendEmployeeMail(newEntryData));
		});
	};
};
